import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@material-ui/core';
import { getHelpCategoriesApi, getHelpSubCategoriesApi } from 'api/help';
import { BackdropCircular } from 'components';
import SubTabsList from './SubTabsList';
import SubTabsForm from './SubTabsForm';


const SubTabs = () => {
  const dispatch = useDispatch();
  const [subCategory, setSubCategory] = useState();
  const { isLoadingHelpCategories, isLoadingHelpSubCategories } = useSelector((state) => state.help);


  useEffect(() => {
    getHelpCategoriesApi({ dispatch });
    getHelpSubCategoriesApi({ dispatch });
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25 my-4 ml-10 pr-10">
      {subCategory ?
        <SubTabsForm subCategory={subCategory} setSubCategory={setSubCategory} />
        :
        <>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setSubCategory({})}
            className="mb-8 ml-4"
          >
            <Icon className="mr-2">add</Icon>
            <span>Add New Sub-Category</span>
          </Button>
          <SubTabsList setSubCategory={setSubCategory} />
        </>
      }
      <BackdropCircular loading={isLoadingHelpSubCategories || isLoadingHelpCategories} />
    </div>
  );
};

export default SubTabs;
